import * as React from "react";
import { Row, Col } from "reactstrap";
import { Query } from "react-apollo";
import * as uuid from "uuid";
import * as moment from "moment";

// GraphQL
import GetCompanyRequests from "../../GraphQL/Queries/GetCompanyRequests";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";
import Table from "../../Components/Table";

// Utils
import { orderDatasetByDateDesc } from "../../Utils/Helpers";

export default class Requests extends React.Component<{ companyId: string }> {
  // Return priority
  returnPriority = (word: string): string => {
    switch (word) {
      case "HIGH":
        return "High";
      case "MEDIUM":
        return "Medium";
      case "LOW":
        return "Low";
      case "NONE":
        return "none";
      default:
        return "none";
    }
  };

  // Return status
  returnStatus = (word: string): string => {
    switch (word) {
      case "ACCEPT":
        return "Accepted";
      case "REJECT":
        return "Rejected";
      case "NONE":
        return "None";
      default:
        return "None";
    }
  };

  render() {
    const { companyId } = this.props;

    return (
      <Query query={GetCompanyRequests} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the reqests</div>;
          }

          let requests = data.allRequests;
          requests = orderDatasetByDateDesc(requests);

          return (
            <Row>
              <Col xs={12} md={12} lg={12}>
                <Table
                  data={requests}
                  columns={[
                    {
                      Header: "ID",
                      accessor: "id",
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Customer",
                      accessor: (companyRequest: any) => {
                        return companyRequest.customer.name;
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Date Of Request",
                      accessor: (companyRequest: any) => {
                        return moment(companyRequest.createdAt).format(
                          "DD/MM/YYYY"
                        );
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Time Of Request",
                      accessor: (companyRequest: any) => {
                        return moment(companyRequest.createdAt).format("LT");
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Title",
                      accessor: "title",
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Priority",
                      accessor: (companyRequest: any) => {
                        return this.returnPriority(companyRequest.priority);
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Status",
                      accessor: (companyRequest: any) => {
                        return this.returnStatus(companyRequest.status);
                      },
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={5}
                  showPaginationTop={false}
                  showPaginationBottom={true}
                />
              </Col>
            </Row>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/Requests.tsx